import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import apolloClient from './useApolloClient';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const GET_CONTACT_QUOTES = gql`
  query ContactQuotesQuery($companyid: ID, $contactid: ID) {
    contactQuotes(companyid: $companyid, contactid: $contactid) {
      QUOTEID
      QUOTENUM
      COMPANYID
      CONTACTID
      ASSIGNEDID
      JOBNAME
      DATEREQUIRED
      CREATEDATE
      VALIDTO
      STATUS
      company {
        COMPANYID
        NAME
      }
      contact {
        CONTACTID
        FIRSTNAME
        LASTNAME
      }
    }
  }
`;

export default function useContactQuotesQuery() {
  return function getContactQuotes(params) {
    provideApolloClient(apolloClient);

    const { result, loading, error, refetch } = useQuery(GET_CONTACT_QUOTES, params, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching quotes:', error.value);
        addAlert('Error fetching quotes', 'high', 4);
      }
    });

    return { result, loading, error, refetch };
  };
}
